/** Administrator identity is not delegated by an all-location permission. */
export function isProtectedAdministratorRole(role: { id?: string; name?: string | null } | null | undefined): boolean {
  if (!role) return false;
  if (role.id === "admin" || role.id === "system_admin") return true;
  const name = role.name?.split("/")[0].trim().toLowerCase();
  return ["admin", "administrator", "system admin", "system administrator", "مدير النظام", "مسؤول النظام"].includes(name || "");
}

export function roleEditBlockReason(actor:{id?:string;name?:string|null}|null|undefined,target:{id?:string;name?:string|null}|null|undefined,canManage:boolean):string|null {
  if(target&&isProtectedAdministratorRole(target))return "The Administrator role is protected and cannot be changed.";
  if(target?.id&&target.id===actor?.id&&!isProtectedAdministratorRole(actor))return "You cannot edit a role you hold. Ask another authorized role manager.";
  if(!canManage)return "An explicit Manage roles permission is required.";
  return null;
}
